import React from "react";
import "./style.css";

function Button({
  className = "",
  variant = "default",
  size = "default",
  asChild = false,
  ...props
}, ref) {
  // const Comp = asChild ? React.Fragment : "button";
  const variantClass =
    variant === "destructive"
      ? "btn-destructive"
      : variant === "outline"
      ? "btn-outline"
      : variant === "secondary"
      ? "btn-secondary"
      : variant === "ghost"
      ? "btn-ghost"
      : variant === "link"
      ? "btn-link"
      : "btn-default";
  const sizeClass =
    size === "sm"
      ? "btn-sm"
      : size === "lg"
      ? "btn-lg"
      : size === "icon"
      ? "btn-icon"
      : "btn-default-size";

  if (asChild && props.children) {
    // If asChild, clone the child and add classes/props
    return React.cloneElement(props.children, {
      ref,
      className: `btn ${variantClass} ${sizeClass} ${props.children.props.className || ""} ${className}`,
      ...props,
    });
  }

  return (
    <button
      ref={ref}
      className={`btn ${variantClass} ${sizeClass} ${className}`}
      {...props}
    />
  );
}

const ForwardedButton = React.forwardRef(Button);
ForwardedButton.displayName = "Button";

export { ForwardedButton as Button };